import {Link, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import isAnError, {AnError} from "../../../model/misc";
import {getItem} from "../../../utils/communication";
import HfMarked from "../../../components/hf-marked";
import UnitedAmount from "../../../components/united-amount";
import ErrorDisplay from "../../../components/error-display";
import IngredientDetail from "../../../components/cooking/ingredient/ingredient-detail";
import parseAnError from "../../../model/misc";

export default function IngredientDetailPage() {
    let {id} = useParams(),
        [error, setError] = useState<string | null>(null),
        [isLoading, setIsLoading] = useState(true),
        [ingredient, setIngredient] = useState<Ingredient | null>(null);

    useEffect(() => {
        document.title = "Ingredient - Hoarfroster";
        setIsLoading(true);

        (async () => {
            let response = await getItem<Ingredient>("/cooking/ingredient/" + id + ":/");

            if (response.code !== 200) {
                setError(parseAnError(response.data).message);
            } else {
                let ingredient = response.data as Ingredient
                setIngredient(ingredient);
                document.title = ingredient.name + " - Hoarfroster";
            }

            setIsLoading(false);
        })();
    }, [id]);

    return (
        <main>
            <div className="container">
                <div className="content space-y-4">
                    <IngredientDetail ingredient={ingredient} isLoading={isLoading}/>
                    <ErrorDisplay error={error}/>
                </div>

                <div className="sidebar space-y-2">
                    <h2>About</h2>
                    <p>欢迎来看烤鹅普拉斯做客！这里有好吃的、好看的、好玩的各种新奇古怪的食谱菜单原材料工具！</p>
                    <p>微信小程序：烤鹅普拉斯</p>
                </div>
            </div>
        </main>
    )
};